module.exports = __webpack_public_path__ + "static/media/template.b1b26b12.png";